export default () => {
  return {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    // redirect_url: `${window.location.origin}/callback`, // must match exactly in Auth0 dashboard too
    redirect_url: window.location.origin, // must match exactly in Auth0 dashboard too
  };
};

